var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"fullscreen":true}},[_c('v-container',{staticClass:"signature-pad__wrapper fill-height ma-0 pa-0",attrs:{"fluid":""}},[_c('SignaturePad',{staticClass:"signature-pad__landscape mx-auto my-auto",attrs:{"preloaded-signature-image":_vm.preloadedSignatureImage,"show-progress":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }